import React, { useRef, useState } from 'react';
import './SettingPswd.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Link } from 'react-router-dom';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const SettingPswd = () => {
    const { user } = useAuth();
    const username = user.user;
    const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

    const [successMessage, setSuccessMessage] = useState('');
    const [otpMessage, setOtpMessage] = useState('');
    const [formData, setFormData] = useState({
        email: username.email || '',
        otp: '',
        password: '',
      });
      
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleOtpInputChange = (index, value) => {
        const newFormData = { ...formData };
    
        // Handle backspace
        if (value === '' && index > 0) {
          // If backspace and not the first digit, move focus to the previous input
          const prevIndex = index - 1;
          const prevInput = inputRefs[prevIndex].current;
          if (prevInput) {
            prevInput.focus();
          }
        } else if (index < 3 && value !== '') {
          // If not the last digit and a value is entered, move focus to the next input
          const nextIndex = index + 1;
          const nextInput = inputRefs[nextIndex].current;
          if (nextInput) {
            nextInput.focus();
          }
        }
    
        newFormData.otp = (newFormData.otp || '').split('');
        newFormData.otp[index] = value;
        newFormData.otp = newFormData.otp.join('');
    
        setFormData(newFormData);
      };

      const handleSendOtp = async () => {
        formData.otp = formData.otp.toString();
        const response = await fetch(API_URL+'/sendOtpForProfilepswd', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        
        if (response.ok) {
          const data = await response.json();
          setOtpMessage(data.message);
        }
      };

    const handlePassword = async() => {
        formData.otp = formData.otp.toString();
        try {
            const response = await fetch(API_URL+'/changePassword', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            });
      
            if (response.status === 200) {
             setSuccessMessage('Password changed successfully!')
             window.alert('Password changed successfully!');
             setTimeout(() => {
              sessionStorage.removeItem('user');
              window.location.reload(true);
              window.location.href = '/SignIn'
             }, 2000);
            } else {
              alert('Invalid Otp');
            }
          } catch (error) {
            console.error(error);
          }
    }

return( 
<div>
    <SideMenuBar></SideMenuBar>
    <div class="content">
        <NewHeader></NewHeader>
            
        <div className='row2'>
            <h3 className='settings_SettingsPage'>Settings</h3>  
        </div>

        <div className='row3_SettingPswd'>
            <div className='heading_SettingPswd'>
                    <Link to='/SettingsPage' className='a_of_heading'><p className='profile_SettingsPage'>&nbsp;Profile&nbsp;</p></Link>
                    <Link to='/SettingPswd' className='a_of_heading'><p className='password_SettingsPage'>&nbsp;Password&nbsp;</p></Link>
                    <Link to='/SettingReport' className='a_of_heading'><p className='report_SettingsPage'>&nbsp;Report&nbsp;</p></Link>
            </div>

            <div className='subrow1_row3_SettingPswd'>
                <p>Please enter the Email ID we will send the OTP in this Email ID. </p>
                    <input className='input_subrow1_row3_SettingPswd' placeholder='Email ID' name='email'
                        value={formData.email}
                        onChange={handleInputChange}></input>
            </div><hr className='hr1_of_SettingPswd'/>
            
            <div className='subrow2_row3_SettingPswd'>
                <p>We have sent you a one time password<br/> on your <b>Email ID</b></p>
                {[0, 1, 2, 3].map((index) => (
          <input
            key={index}
            ref={inputRefs[index]}
            id={`otp-input-${index}`}
            className='circle_input_subrow2_row3_SettingPswd'
            placeholder=''
            maxLength='1'
            onChange={(e) => handleOtpInputChange(index, e.target.value)}
          ></input>
        ))}<br/><br/>
                <button className='otp_btn_Setting' onClick={handleSendOtp}><b>Send OTP</b></button>
                <button className='otp_btn_Setting' onClick={handleSendOtp}><b>Resend OTP</b></button><br/><br/>
                {otpMessage && <label>{otpMessage}</label>}<br />
            </div><hr className='hr2_of_SettingPswd'/>

            <div className='subrow3_row3_SettingPswd'>
                <p>Change Password</p>
                <input className='input_subrow3_row3_SettingPswd' placeholder='Enter Password' name='password'
                        value={formData.password}
                        onChange={handleInputChange}></input><br/><br/>
                <input className='input_subrow3_row3_SettingPswd' placeholder='Confirm Password' name='password'
                        value={formData.password}
                        onChange={handleInputChange}></input><br/>
                {successMessage && <label>{successMessage}</label>}<br />
                <button className='update_btn_SettingPswd' onClick={handlePassword}>Update</button>
            </div>
            
        </div>

        
        
    <br/><br/>
    </div>
</div>
    

 )
}


export default SettingPswd;